export const COMMON_FAULTS = [
  "Schermo rotto",
  "Batteria da sostituire",
  "Non si accende",
  "Problema di ricarica",
  "Danni da liquido",
  "Fotocamera non funziona",
  "Audio/altoparlante",
  "Tasti non funzionanti",
  "Vetro posteriore rotto",
  "Software/aggiornamento",
];
